module.exports = __webpack_public_path__ + "pc/img/modal_25.77a9fa43.png";